import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { sendGa4PageView } from '../utils/analytics';

export function usePageView(): void {
  const location = useLocation();

  useEffect(() => {
    sendGa4PageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
}
